import { useEffect, useState } from 'react';

export const useDebouncedValue = (value: string, delayMs: number): string => {
  const [debounced, setDebounced] = useState<string>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
};
